import { observer } from "mobx-react-lite/dist"
import { useProposalsEditStore } from "../ProposalsEditStore"
import { ServiceAutoCompleteMultiple } from "features/services/service-item/ServiceAutocomplete"
import { useEffect } from "react"
import { useProposalsEditServicesStore } from "./ProposalsEditServicesStore"

export default observer(function ProposalsEditServicesSelect() {
   const proposalsEditStore = useProposalsEditStore()
   const proposalsEditServicesStore = useProposalsEditServicesStore()
   const serviceStore = proposalsEditStore.sp.serviceStore

   // Basicly, listen for the var lastAddedOrEditedServiceId once the service drawer closes. Add this id to our list and reset the var
   useEffect(() => {
      if (!serviceStore.serviceDrawer.visible && serviceStore.lastAddedOrEditedServiceId) {
         const lastAddedId = serviceStore.lastAddedOrEditedServiceId
         serviceStore.lastAddedOrEditedServiceId = undefined
         proposalsEditServicesStore.addService(lastAddedId)
      }
   }, [proposalsEditServicesStore, serviceStore, serviceStore.lastAddedOrEditedServiceId])

   return proposalsEditServicesStore.formHandler.selectedServices.bindInput((ip) =>
      <ServiceAutoCompleteMultiple
         services={proposalsEditStore.services}
         autoFocus
         onNewServiceAdd={proposalsEditServicesStore.onNewServiceAdded}
         {...ip}
         label='Find or create a service'
      />
   )
})
